module.exports = __webpack_public_path__ + "static/img/systemMonitorManage.50209d9d.png";